// ===== TT Tooltips (Impact) v2 =====
// يحوّل ?{النص} أو ؟{النص} إلى Tooltip HTML داخل أي محتوى Rich text/Prose
(function () {
  // ندعم كلتا علامتي الاستفهام: الانكليزية والعربية
  const PATTERN = /[?؟]\{([^}]+)\}/g;

  // أماكن شائعة في Impact لعرض نصوص الـ Rich text
  const SCOPE_SELECTORS = [
    '.product-info .prose',
    '.product-info .rte',
    '.product-info__accordion .prose',
    '.product-info__text .prose',
    '.prose',
    '.rte'
  ];

  function makeTooltipHTML(text){
    const safe = text.replace(/</g,'&lt;').replace(/>/g,'&gt;');
    return `<span class="tt" tabindex="0" aria-label="تعريف">
              <span class="tt-q">❓</span>
              <span class="tt-box">${safe}</span>
            </span>`;
  }

  function convertInNode(el){
    if (!el || el.closest?.('.tt')) return;

    // لا نحوّل إذا النص داخل عنصر إدخال أو كود
    const tag = (el.tagName || '').toLowerCase();
    if (['script','style','code','pre','textarea','input'].includes(tag)) return;

    const html = el.innerHTML;
    if (!html || html.indexOf('{') === -1) return;

    // استبدال الأنماط
    const replaced = html.replace(PATTERN, (_, tip) => makeTooltipHTML(tip));
    if (replaced !== html) el.innerHTML = replaced;
  }

  function runOnce(root=document){
    SCOPE_SELECTORS.forEach(sel => {
      root.querySelectorAll(sel).forEach(scope => {
        // حول العناصر الداخلية الشائعة
        scope.querySelectorAll('p, li, div, span').forEach(convertInNode);
        // وحوّل المحتوى المباشر أيضًا
        convertInNode(scope);
      });
    });
  }

  // شغّل عند التحميل
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => runOnce());
  } else {
    runOnce();
  }

  // راقب أي تغيير DOM (Impact قد يعيد حقن محتوى المنتج)
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'childList') {
        m.addedNodes.forEach(node => {
          if (node.nodeType === 1) runOnce(node);
        });
      } else if (m.type === 'attributes' && m.target) {
        runOnce(m.target);
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true, attributes: true });

  // دعم اللمس/النقر لفتح وإغلاق البالون
  document.addEventListener('click', (e)=>{
    const tt = e.target.closest('.tt');
    document.querySelectorAll('.tt.is-open').forEach(x => { if (x !== tt) x.classList.remove('is-open'); });
    if (tt) tt.classList.toggle('is-open');
  });
})();